import React from 'react';
import { Capacitor } from '@capacitor/core';
import './BiometricPromptModal.scss';
import faceIcon from '../images/face-icon.svg';

function BiometricPromptModal({ onEnable, onSkip, onClose }) {
  // Prevent focus issues
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="modal-overlay biometric-modal-overlay" 
      onClick={handleOverlayClick}
      onMouseDown={(e) => e.preventDefault()}
    >
      <div 
        className="modal biometric-prompt-modal" 
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="biometric-icon">
            <img src={faceIcon} alt="Face ID" />
          </div>
          <h2>Use Face ID to Sign In?</h2>
          <p>
            You can use Face ID to sign in quickly and securely next time.
          </p>
          <div className="modal-buttons">
            <button 
              onClick={onEnable} 
              className="primary-btn"
              onFocus={(e) => e.target.style.outline = 'none'}
            >
              Use Face ID
            </button>
            <button 
              onClick={onSkip} 
              className="secondary-btn"
              onFocus={(e) => e.target.style.outline = 'none'}
            >
              Not Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BiometricPromptModal;

